import styled from "styled-components";

const NewsCountSpan = styled("div")`
  font-size: 0.75em;
  float: right;
`;

export default NewsCountSpan;
